import React from 'react';
import { Modal, Button } from 'react-bootstrap';

const ConfirmDialog = ({
  isVisible,
  title = 'Confirm Action',
  message,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  confirmVariant = 'danger',
  onConfirm,
  onCancel,
  size = 'md'
}) => {
  const handleConfirm = () => {
    onConfirm();
  };

  const handleCancel = () => {
    onCancel();
  };

  return (
    <Modal 
      show={isVisible} 
      onHide={handleCancel}
      size={size}
      centered
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="d-flex align-items-center">
          <i className={`fa fa-exclamation-triangle text-${confirmVariant} me-3 fs-4`}></i>
          <div>
            {typeof message === 'string' ? (
              <p className="mb-0">{message}</p>
            ) : (
              message
            )}
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleCancel}>
          {cancelText}
        </Button>
        <Button variant={confirmVariant} onClick={handleConfirm}>
          {confirmText}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmDialog;